import { render, staticRenderFns } from "./ActionsConfiguration.vue?vue&type=template&id=c49fd3fc"
import script from "./ActionsConfiguration.vue?vue&type=script&lang=js"
export * from "./ActionsConfiguration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports